var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ClassifierTree/nodes/common.tsx";
import "core-js/modules/es.array.map.js";
import { Typography } from '@gmini/ui-kit/lib/Typography';
import { jsx as _jsx } from "react/jsx-runtime";
export function renderTooltipTitle(rows) {
  return rows.map(function (row, idx) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      _jsx(Typography, {
        variant: "body2",
        children: row
      }, idx)
    );
  });
}